export default __webpack_public_path__ + "static/media/464.da06bcc7.gif";